<template>
	<div id="email-capture">
		<div class="inner">
			<a href="#" @click.prevent="$emit('close')" class="cls"><i class="far fa-times-circle"></i></a>

			<div class="copy">
				<h2>Join &amp; Save</h2>
				<p>Join the online Armslist community and subscribe to our newsletter for the latest deals and news!</p>
			</div>

			<!-------------------------------------------------
				Init State
			---------------------------------------------------->
			<div v-if="state == 'init'">
				<div>
					<form @submit.prevent="submit">
						<div>
							<input type="text" name="email" v-model="email" placeholder="Enter your email address" :class="{ err: errEmail }">
						</div>
						<div>
							<input type="text" name="phone" v-model="phone" placeholder="Enter your phone number" :class="{ err: errPhone }">
						</div>
						<div>
							<input type="submit" value="Join">
						</div>
					</form>
				</div>
				<div class="disclaimer">
					<small>
						by clicking "join" you agree to receive email communications from Armslist
					</small>
				</div>
			</div>

			<!-------------------------------------------------
				Success State
			---------------------------------------------------->
			<div v-if="state == 'done'" class="grn">
				<p>You have successfully joined!</p>
				<a href="#" @click.prevent="$emit('close')">close</a>
			</div>

		</div>
	</div>
</template>

<script>
const axios = require('axios');
const qs = require('query-string')
import isEmail from 'validator/lib/isEmail';

//
export default {
	components: {},
	data: function() {
		return {
			state: 'init',
			email: "",
			phone: "",
			isSubmitting: false,
			errEmail: false,
			errPhone: false
		}
	},
	computed: {},
	methods: {
		submit() {
			
			//
			if( this.isSubmitting ) return false;
			this.isSubmitting = true;
			this.errEmail = false;
			this.errPhone = false;

			//validate email
			if( ! isEmail(this.email) ) {
				this.errEmail = true;
				this.isSubmitting = false;
				return false;
			}

			//fix phone
			let phone = (""+this.phone).replace(/[^0-9]/g, '');

			//submit
			axios.post("https://hosted.mailwizz.armslist.techdaddies.com/armslist-api/subscribe.php", qs.stringify({
				LIST: 'hb262pzv2jb6e',
				EMAIL: this.email,
				PHONE: phone
			}), {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			})
				.then(() => {
					this.isSubmitting = false;
					this.state = 'done';
				})
				.catch(e => {
					alert(e);
					this.isSubmitting = false;
				});
		}
	}
};
</script>

<style lang="scss">
#email-capture {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	background: rgba(0,0,0,0.3);
	padding: 50px 10px 10px;
	display: flex;
	justify-content: center;
	align-items: flex-start;

	.inner {
		position: relative;
		background: #fff;
		padding: 30px;
		text-align: center;
		max-width: 100%;

		.cls {
			position: absolute;
			top: 15px;
			right: 15px;
			text-decoration: none;
			font-size: 20px;
			color: #333;
		}
	}

	.copy {
		max-width: 400px;
		margin: 0 auto 30px;
	}

	h2 {
		margin-bottom: 10px;
	}

	form {
		margin-bottom: 30px;
	}

	input[type=text] {
		flex-grow: 1;
		display: block;
		width: 200px;
		height: 42px;
		margin: 0 auto 10px;
		padding: 0 40px 0 10px;
		line-height: 42px;
		border-radius: 4px;
		border: #cdc7a2 2px solid;
		background-color: #fff;
		color: #515151;
		-webkit-appearance:none;

		&.err {
			border-color: #d41b00;
		}
	}

	input[type=submit] {
		flex-shrink: 0;
		width: 150px;
		padding: 0 15px;
		font-size: 16px;
		line-height: 40px;
		background: #cdc7a2;
		color: #3b3f47;
		text-align: center;
		cursor: pointer;
		outline-style: none;
	}

	.disclaimer {
		color: #a9a3a3;
	}

	.grn {
		color: #26cc44;
		p {
			margin-bottom: 15px;
		}
		a {
			color: #000;
		}
	}

	//
	@media ( min-width: 480px ) {
		form {
			// display: flex;
			// justify-content: center;
			// align-items: center;
		}
		input[type=text] {
			// margin-bottom: 0;
		}
		input[type=submit] {
			// margin-left: 10px;
		}
	}
}
</style>